import React from 'react';
import { ApolloError, useQuery } from '@apollo/client';
import { CookbookMeal, MealQueryResult } from '../types';
import CookbookMealQuery from './CookbookMealQuery';

type result = {
  loading: boolean;
  error?: ApolloError;
  meal?: CookbookMeal;
  refetch: () => void;
};

interface ICookbookMealConnectorApollo {
  children: (result: result) => React.ReactElement;
  mealId: number;
}

const CookbookMealConnectorApollo: React.FC<ICookbookMealConnectorApollo> = ({
  children,
  mealId,
}) => {
  const { loading, error, data, refetch } = useQuery<MealQueryResult>(CookbookMealQuery, {
    variables: { mealId },
  });

  const result: result = {
    loading,
    error,
    refetch,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.meal = data?.cookbook.meal;
  }

  return children(result);
};

export default CookbookMealConnectorApollo;
